<div class="page-container">
  <app-configurable-grid
    headerTitle="Documents"
    [config]="gridConfig">
  </app-configurable-grid>
</div>
